<template>
    <div class="exams-main">
        <div class="hasCategory ">
             <div class="exams-panel">
                <div class="exams-panel-body">
                       <div class="table-toolbar flex align-cen">
                            <div class="table-toolbar-right  flex align-cen">
                              
                            </div>
                        </div>
                          <div class="exams-list">
                             <div class="public-tit flex align-cen" style="margin:10px 16px">
                                    <div class="public-tit-list">
                                        <i class="icon-al-file-fill"></i>  学习记录
                                    </div>
                                </div>
                                 <div class="exams-scrollbar" v-if="itemList && itemList.length">
                                <div class="exams-item" v-for="(item,index) in itemList" >
                                    <div class="exams-item-info flex align-cen">
                                         <img :src="item.logo" alt="" class="courseimg">
                                         <div class="exams-item-info-rule flex">
                                            <div class="exams-item-paperName flg">
                                                    {{item.courseName}}
                                                </div>
                                                <div class="dateTit flg">
                                                    {{item.lastRecordChapterMap.parentHeadline}} {{item.lastRecordChapterMap.serialNum}}{{item.lastRecordChapterMap.headline}}
                                                </div>
                                                 <div class="dateTit  flg " >
                                                   <el-progress :percentage="item.progress" :stroke-width="16"  :text-inside="true"></el-progress>
                                                </div>
                                                 <!-- <div class="dateTit dateTit1 flg flex">
                                                    <span >{{item.progress}}</span>
                                                </div> -->
                                         </div>
                                         <div class="mft">
                                            <span  class="coursebtn" @click="openVideo(item)">继续学习</span>
                                         </div>
                                    </div>
                                </div>
                            </div>
                          <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                          </div>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import {courserRecordList} from "@/api/enterprise/index"   //学习记录分页
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'learningRecord',
      components:{
      paginaTion
    },
    data () {
        return {
            totalCount:0,
            businessInfo:{},
            itemList:[],
            currentPage:1,
            PageSize:10,
        }
    },
    created () {
           if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
                     this.getList()
    },
    methods: {
            // 打开试听课
        openVideo(data){
            const newurl = this.$router.resolve({name: 'enCourseVideo', query: {
                id: data.courseId,
                 chapterId:data.lastRecordChapterMap.id,
                title:data.courseName,
                index:'',
                childIndex:''
                 }})
       window.open(newurl.href,'_blank')
        this.getList()
        },
        // 获取学习记录分页
        getList(){
            courserRecordList({businessId:this.businessInfo.id,size:this.PageSize, current:this.currentPage})
            .then(res =>{
                this.itemList = res.data.records
                this.totalCount = res.data.total
            })
        },
            emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
    },
}
</script>
<style lang="scss" scoped>
.exams-item{
    width: auto !important;
    .exams-item-info{
        position: relative;
        .courseimg{
            width: 300px !important;
            height: 210px !important;
        }
        .exams-item-info-rule{
            flex-direction: column;
            height: 200px;
            .flg{
                flex-grow: 1;
            }
        }
        .dateTit{
            font-size: 14px;
            font-weight: 500;
            line-height: 30px;
            color: #666;
        }
        .dateTit1{
            align-items: flex-end;
             font-weight: 400;
             color: rgb(180, 183, 193);
             font-size: 13px;
        }
        .gqimg{
           width: 300px;

           position: absolute;
           right: 100px;
        }
        .coursebtn{
            display: block;
            background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%) !important;
                color: #fff;
                height: 36px;
                padding: 0px 18px;
                border-radius: 4px !important;
                text-decoration: none !important;
                white-space: nowrap;
                cursor: pointer;
                border: 1px solid #e4e4e4;
                box-sizing: border-box;
                line-height: 36px;
                margin-right: 20px;
                width: 120px;
                text-align: center;
                margin: -20px 0 0 0;
        }
        .coursebtn1{
            display: block;
            width: 120px;
                 height: 36px;
                 line-height: 36px;
                padding: 0px 18px;
                margin: 20px 0 0 0;
                                margin-right: 20px;
                border: 1px solid rgba(1, 87, 255, 0.2);
                border-radius: 4px;
                box-sizing: border-box;
                color: #0157ff;
                cursor: pointer;
                transition: background-color 0.3s linear 0s, border-color 0.3s linear 0s;
                text-align: center;
        }
    }
}
::v-deep{
    .jiange{
    text-align: center !important;
}
.el-progress-bar__innerText{
    color: #fff !important;
}
}
</style>